<template>
 <router-view></router-view>
</template>

<script>
import { useAuthStore, useSocketStore } from '@/state/pinia'

export default {
  name: 'App',
  components: {
  },
  async created() {
    const auth = useAuthStore()

    if (auth.loggedIn) {
      await auth.validate();
    }

    const socketStore = useSocketStore();

    socketStore.initializeSocket();
  },
  beforeUnmount() {
    const socketStore = useSocketStore();
    socketStore.disconnectSocket();
  },
}
</script>
